import {Box, css, styled} from '@mui/material';
import Icon from 'presentation/icons';
import type {StyledProps} from './types';

const StyledBox = styled(Box)<StyledProps>`
	width: 100%;
	${({theme}) => theme.breakpoints.up('lg')} {
		padding: 4px;
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		margin-inline: -16px;
		& .slide {
			flex-basis: 90%;
		}

		& .slide:first-of-type {
			flex-basis: 94%;
			padding-left: 16px;
		}

		& .slide:last-of-type {
			flex-basis: 94%;
			padding-right: 16px;
		}
	}

	${({$isSingleItem}) =>
		$isSingleItem &&
		css`
			${({theme}) => theme.breakpoints.down('sm')} {
				& .slide {
					flex-basis: 100%;
				}

				& .slide:first-of-type {
					flex-basis: 100%;
				}

				& .slide:last-of-type {
					flex-basis: 100%;
				}
			}
		`}
`;

const StyledImage = styled('img')`
	max-width: 100%;
	border-radius: 16px;
	${({theme}) => theme.breakpoints.down('sm')} {
		border-radius: 4px;
	}

	${({theme}) => theme.breakpoints.up('lg')} {
		width: 100%;
	}
`;

const StyledLink = styled('a')`
	display: flex;
	height: 100%;
	position: relative;
`;

const StyledIcon = styled(Icon)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 40px;
	height: 40px;
	color: ${({theme}) => theme.palette.primary.main};
`;

const StyledDotButton = styled('div')`
	background-color: ${({theme}) => theme.palette.action.hover};
	width: 8px;
	height: 8px;
	border-radius: 50%;
`;

const DotsContainer = styled('div')`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	margin-top: 8px;
	padding-inline: 24px;
`;

export {StyledBox, StyledDotButton, DotsContainer, StyledImage, StyledLink, StyledIcon};
